import React from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { Helmet } from 'react-helmet';
import AdvancedSearchContentV2 from '../components/advancedSearch/AdvancedSearchContentV2';
import { AdvancedSearchV2Provider } from '../components/advancedSearch/AdvancedSearchV2Context';

const Container = styled.div`
  .table-container {
    width: 100%;
    position: relative;

    .column {
      &.col0 {
        width: 16%;
      }
    }
  }
`;

export const parseParams = (location) => {
  const { search } = location;
  const args = search.replace('?', '');

  if (args.length === 0) {
    return {};
  }

  const params = {};
  const argsList = args.split('&');

  for (let i = 0; i < argsList.length; i += 1) {
    const [key, val] = argsList[i].split('=');

    if (!val) continue; // Skip empty values

    // Handle boolean values (true/false) - keep as arrays for filter compatibility
    if (val === 'true' || val === 'false') {
      params[key] = [val === 'true'];
    } else if (key === 'country' || key === 'city' || key === 'region') {
      // Handle location parameters
      if (!params.location) params.location = {};
      const decodedValue = decodeURIComponent(val).replace('_', ' ').replace(/%20/gi, ' ');
      params.location[key] = decodedValue;
    } else {
      const parsedValue = val
        .split(',')
        .map((v) => decodeURIComponent(v).replace('_', ' ').replace(/%20/gi, ' '));
      params[key] = parsedValue;
    }
  }

  return params;
};

export default function AdvancedSearch() {
  const location = useLocation();
  const params = parseParams(location);

  return (
    <Container>
      <Helmet>
        <title>Deal Feed - TV CRM</title>
      </Helmet>

      <AdvancedSearchV2Provider params={params}>
        <AdvancedSearchContentV2 />
      </AdvancedSearchV2Provider>
    </Container>
  );
}
